import React from 'react';
import c from 'classnames';

interface Props {
  icon: string;
  variant?: string;
  size?: 'xs' | 's' | 'sm' | 'md' | 'lg';
  orientation?: 'left' | 'right' | 'up' | 'down';
  className?: string;
}

const Icon: React.FC<Props> = ({
  icon,
  variant = '0',
  size = 'sm',
  orientation = 'right',
  className,
  ...props
}) => {
  const classNames = c(
    className,
    'icon',
    `icon-${icon}`,
    `icon-variant-${variant}`,
    `icon-size-${size}`,
    `icon-orientation-${orientation}`,
  );

  return <div {...props} className={classNames} />;
};

export default Icon;
